<template>
  <VueApexCharts
    type="bar"
    :height="chartHeight"
    :options="chartOptions"
    :series="chartSeries"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ReviewChart',
  props: {
    reviewData: {
      type: Array,
      required: true
    }
  },
  components: {
    VueApexCharts
  },
  computed: {
    chartHeight () {
      return Math.max(this.reviewData.length * 80, 300) // minimum height of 300px for better visibility
    },
    sortedReviewData () {
      // sort descending by total review requests
      return [...this.reviewData].sort((a, b) => {
        const totalA = (a.review_requested || 0)
        const totalB = (b.review_requested || 0)
        return totalB - totalA
      })
    },
    chartSeries () {
      return [
        {
          name: 'Review On-Time',
          data: this.sortedReviewData.map(m => (m.review_requested || 0) - (m.review_overdue || 0))
        },
        {
          name: 'Review Overdue',
          data: this.sortedReviewData.map(m => m.review_overdue || 0)
        }
      ]
    },
    chartOptions () {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          height: this.chartHeight
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
            dataLabels: {
              position: 'center' // show individual values inside bar
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const seriesIndex = opts.seriesIndex
            const dataPointIndex = opts.dataPointIndex

            // Show individual values for all segments
            if (val > 0) {
              // For the overdue series, show total at the end
              if (seriesIndex === 1) { // Review Overdue - show total at end
                const total = 
                  opts.w.config.series[0].data[dataPointIndex] +
                  opts.w.config.series[1].data[dataPointIndex]
                return total > 0 ? val : ''
              } else {
                // Show individual values for on-time segments
                return val
              }
            }

            return ''
          },
          style: {
            fontSize: '11px',
            fontWeight: 'bold',
            colors: ['#fff'] // white for individual counts in center
          },
          offsetX: 0 // no offset for individual counts
        },
        colors: [
          '#059669', // Review On-Time (green)
          '#DC2626'  // Review Overdue (red)
        ],
        xaxis: {
          categories: this.sortedReviewData.map(m => m.manager_name || 'Unassigned'),
          labels: {
            formatter: function (val) {
              return Math.round(val).toString()
            }
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        }
      }
    }
  }
}
</script>
